import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";

export default function AddProductButton({ handleOpen }) {
  const { t } = useTranslation();

  return <PrimaryButton text={t("add_new_product")} onClick={handleOpen} />;
}
